/**
 * Keep only the exports Vuex will accept as actions.
 *
 * Action modules are imported with `import * as actions`, and the `main` module
 * additionally barrels `export * from "./<file>"`, so ANY export in those files
 * lands in the actions object — including plain constants that sit next to the
 * actions using them (PRESERVED_LOADING_FIELDS in main/actions/events.js, or a
 * page-size constant in admin/actions.js).
 *
 * Vuex asserts every entry is a function or `{ handler }`, and a non-conforming
 * value throws during store construction, which blanks the whole app on boot:
 *
 *   [vuex] actions should be function or object with "handler" function
 *   but "actions.LOGS_PAGE_LIMIT" in module "admin" is 50.
 *
 * That assert only runs in dev builds, so it fails loudly in `quasar dev` and
 * every e2e run while a production bundle boots fine — an easy trap to ship
 * past, which is why both store modules filter rather than just one.
 */
export default function onlyActions(rawActions) {
  return Object.fromEntries(
    Object.entries(rawActions).filter(
      ([, value]) =>
        typeof value === "function" || typeof value?.handler === "function"
    )
  );
}
